import React from 'react';
import { Link, useLocation} from 'react-router-dom';
import { Row, Col, Image, Space, Typography, Card, Button, Grid } from 'antd';
import { CalendarOutlined, MailOutlined } from '@ant-design/icons';
import Logo from '../../../assets/img/WCHSS.png';
import LogoUniversitasBinawan from '../../../assets/img/logo-universitas-binawan.png';
import KampusMerdeka from '../../../assets/img/kampus-merdeka.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Footers() {
  let location = useLocation()
  const { xxl, xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        location.pathname === '/registration' || location.pathname === '/registration/success' || location.pathname === '/registration/payment-confirmation' || location.pathname === '/registration/payment-confirmation/success' || location.pathname === '/registration/check-status' || location.pathname === '/registration/info-and-payment-method' ?
          null
        :
          xs ?
            <Row justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff', padding: 16 }}>
              <Col span={24}>
                <Card style={{ width: '100%', backgroundColor: '#e8ebed', borderRadius: 12, boxShadow: '0 2px 8px 1px #f1f3f4' }}>
                  <Row justify="space-around" align="middle" gutter={[0,8]} style={{ textAlign: 'center' }}>
                    <Col xs={24} md={12}>
                      <Space direction='vertical' size={0}>
                        <Text type='secondary' style={{ fontSize: 20 }}>Ready to Grow your Experience?</Text>
                        <Text style={{ fontSize: 26 }}>Best way to get your Chance</Text>
                      </Space>
                    </Col>
                    <Col xs={24} style={{ textAlign: 'center' }}>
                      <Link to='/registration'>
                        <Button className='m-button-register' icon={<CalendarOutlined style={{ color: '#E5BB66' }} />}>Register Now</Button>
                      </Link>
                    </Col>
                    <Col xs={24} style={{ textAlign: 'center' }}>
                      <Link to='/contact-us'>
                        <Button className='m-button-contact' icon={<MailOutlined style={{ color: '#0D6E49' }} />}>Contact Us</Button>
                      </Link>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          :
            <Row justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff', padding: xxl ? '50px 300px 0px 300px' : '50px 50px 0px 50px' }}>
              <Col span={24}>
                <Card style={{ width: '100%', height: 200, backgroundColor: '#e8ebed', borderRadius: 12, boxShadow: '0 2px 8px 1px #f1f3f4', padding: 35 }}>
                  <Row justify="space-around" align="middle" gutter={64}>
                    <Col xs={24} md={12} xxl={11}>
                      <Space direction='vertical' size={0}>
                        <Text type='secondary' style={{ fontSize: 22 }}>Ready to Grow your Experience?</Text>
                        <Text style={{ fontSize: 30 }}>Best way to get your Chance</Text>
                      </Space>
                    </Col>
                    <Col xs={24} md={12} xxl={13} style={{ textAlign: 'center' }}>
                      <Space style={{ float: 'right' }}>
                        <Link to='/registration'>
                          <Button className='button-register' icon={<CalendarOutlined style={{ color: '#E5BB66' }} />}>Register Now</Button>
                        </Link>
                        <Link to='/contact-us'>
                          <Button className='button-contact' icon={<MailOutlined style={{ color: '#0D6E49' }} />}>Contact Us</Button>
                        </Link>
                      </Space>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
      }
      {
        xs ?
          <Row className='content-body' gutter={[0,16]} justify="space-around" align="middle" style={{ backgroundColor: '#fff' }}>
            <Col span={12}>
              <Image
                width={'70%'}
                src={Logo}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={12}></Col>
            <Col span={24}>
              <Row gutter={10} align="top">
                <Col span={11}>
                  <Text style={{ fontSize: 14 }}>Jl. Dewi Sartika No.25-30, Kalibata, Kec. Kramat jati, Kota Jakarta Timur, Daerah Khusus Ibukota Jakarta 13630</Text>
                </Col>
                <Col span={7}>
                  <Space direction='vertical' size={0}>
                    <Link to='/' style={{ fontSize: 14 }}>Home</Link>
                    <Link to='/about' style={{ fontSize: 14 }}>About</Link>
                    <Link to='/call-for-papers' style={{ fontSize: 14 }}>Call For Papers</Link>
                    <Link to='/sponsorship' style={{ fontSize: 14 }}>Sponsorship</Link>
                  </Space>
                </Col>
                <Col span={6}>
                  <Space direction='vertical' size={0}>
                    <Link to='/registration' style={{ fontSize: 14 }}>Registration</Link>
                    <Link to='/publications' style={{ fontSize: 14 }}>Publications</Link>
                    <Link to='/contact-us' style={{ fontSize: 14 }}>Contact Us</Link>
                  </Space>
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Image
                width={'100%'}
                src={LogoUniversitasBinawan}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={8}>
              <Image
                width={'100%'}
                src={KampusMerdeka}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
          </Row>
        :
          <Row className='content-body' gutter={[0,16]} justify="space-around" align="middle" style={{ backgroundColor: '#fff' }}>
            <Col span={4}>
              <Image
                width={'70%'}
                src={Logo}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={20}></Col>
            <Col span={10}>
              <Row gutter={32} align="top">
                <Col span={9}>
                  <Text style={{ fontSize: 14 }}>Jl. Dewi Sartika No.25-30, Kalibata, Kec. Kramat jati, Kota Jakarta Timur, Daerah Khusus Ibukota Jakarta 13630</Text>
                </Col>
                <Col span={6}>
                  <Space direction='vertical' size={0}>
                    <Link to='/' style={{ fontSize: 14 }}>Home</Link>
                    <Link to='/about' style={{ fontSize: 14 }}>About</Link>
                    <Link to='/call-for-papers' style={{ fontSize: 14 }}>Call For Papers</Link>
                    <Link to='/sponsorship' style={{ fontSize: 14 }}>Sponsorship</Link>
                  </Space>
                </Col>
                <Col span={6}>
                  <Space direction='vertical' size={0}>
                    <Link to='/registration' style={{ fontSize: 14 }}>Registration</Link>
                    <Link to='/publications' style={{ fontSize: 14 }}>Publications</Link>
                    <Link to='/contact-us' style={{ fontSize: 14 }}>Contact Us</Link>
                  </Space>
                </Col>
                <Col span={3}></Col>
              </Row>
            </Col>
            <Col span={8}></Col>
            <Col span={3}>
              <Image
                width={'100%'}
                src={LogoUniversitasBinawan}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={3}>
              <Image
                width={'100%'}
                src={KampusMerdeka}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Footers